module.exports = __webpack_public_path__ + "static/img/logos.986110a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos.svg
// module id = 0bdf
// module chunks = 1